// @flow strict

import { createTheme } from '@material-ui/core/styles';

// create custom design with custom settings
const defaultTheme = createTheme({
  spacing: 5,
  palette: {
    primary: {
      main: '#ff6600',
      contrastText: '#ffffff',
    },
    contact: {
      main: '#f06',
      contrastText: '#ffffff',
    },
  },
});

defaultTheme.overrides = {
  MuiButton: {
    root: {
      whiteSpace: 'nowrap',
      borderRadius: 5,
      boxShadow: 'none !important',
      textTransform: 'none',
      paddingTop: 0,
      paddingBottom: 0,
      fontWeight: 400,
    },
    sizeSmall: {
      fontSize: 13,
      lineHeight: '34px',
      height: 34,
    },
    sizeLarge: {
      height: 42,
      lineHeight: '42px',
      fontSize: 15,
      padding: '0 30px',

      [defaultTheme.breakpoints.up('md')]: {
        height: 52,
        lineHeight: '52px',
        fontSize: 15,
      },
      [defaultTheme.breakpoints.up('lg')]: {
        fontSize: 16,
      },
    },
    outlined: {
      color: '#979797',
      border: '2px solid #979797',

      '&:hover': {
        opacity: 0.9,
        background: 'none',
      },
    },
    outlinedPrimary: {
      border: '2px solid #ff6600',
    },
    outlinedSizeSmall: {
      padding: '0 15px',
      lineHeight: '30px !important',
    },
    containedSizeSmall: {
      padding: '0 15px',
    },
  },
};

export { defaultTheme };
